<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<a href="{{ url }}" target="_blank" rel="noopener noreferrer" class="lf-link-v2">
    <span>{{ text }}</span>
    <i class="fa fa-external-link"></i>
</a>
